import { flexCenter, flexRow } from '@anm/styles/helpers';
import styled from 'styled-components';

export const Wrapper = styled.div`
  ${flexRow};
  ${flexCenter};
  margin-top: 8px;
  margin-bottom: 7px;
`;

export const TabButton = styled.span<{ isActive: boolean }>`
  ${flexCenter};
  width: 205px;
  height: 40px;
  margin: 0 5px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 700;
  border-radius: 5px;
  color: ${({ theme }) => theme.textColor};
  background: ${({ theme, isActive }) => (isActive ? theme.activeDestinationTabBg : theme.dropdownAndModalBg)};
`;
